<template>
  <div>
    <api></api>
  </div>
</template>


<script>
import Api from './../../components/account/api';
export default {
  data: () => ({}),
  metaInfo() {
    return {
      title: this.$i18n.t('account.api.title'),
    };
  },
  components: {
    Api
  }
}
</script>